import { render } from "./DownloadButton.vue?vue&type=template&id=b7841fbe&scoped=true&ts=true"
import script from "./DownloadButton.vue?vue&type=script&lang=ts"
export * from "./DownloadButton.vue?vue&type=script&lang=ts"

import "./DownloadButton.vue?vue&type=style&index=0&id=b7841fbe&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7841fbe"]])

export default __exports__